module.exports = __webpack_public_path__ + "img/ford-plaza-gal-3.1fa5f2e7.jpg";